// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph__2S5BO"};